<template>
  <Modal title="添加反馈" v-model="visible" :width="600">
    <Form ref="timeForm" class="form" :label-width="90"
      :model="tempLessonParam" :rules="timeRule">
      <Row>
        <Col :span="26">
          <Form-item label="老师ID">
            <Input v-model="tempLessonParam.tchId" placeholder="多个老师用英文逗号隔开"></Input>
          </Form-item>
        </Col>
        <Col :span="26">
          <Form-item label="反馈类型">
            <Select filterable transfer v-model.number="tempLessonParam.feedBackType" @on-change="onChangeFeedBackType">
              <Option value="加开固定时间">加开固定时间</Option>
              <Option value="加开短期固定时间">加开短期固定时间</Option>
              <Option value="加开临时时间">加开临时时间</Option>
              <Option value="开绑定权限">开绑定权限</Option>
              <Option value="开临时约课权限">开临时约课权限</Option>
              <Option value="其他">其他</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="26" v-if="tempLessonParam.feedBackType === '其他'">
          <Form-item label="留言内容">
            <Input type="textarea" :rows="4" v-model="tempLessonParam.otherContent" placeholder="请输入留言内容">
            </Input>
          </Form-item>
        </Col>
        <Col :span="26" v-if="tempLessonParam.feedBackType === '开绑定权限'">
          <Form-item label="申请理由">
            <Input type="textarea" :rows="3" v-model="tempLessonParam.otherContent" placeholder="请输入开绑定权限的理由"></Input>
          </Form-item>
        </Col>
        <Col :span="26" v-if="tempLessonParam.feedBackType === '开临时约课权限'">
          <Form-item label="申请理由">
            <Input type="textarea" :rows="3" v-model="tempLessonParam.otherContent" placeholder="请输入开临时约课权限的理由"></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <Form v-if="tempLessonParam.feedBackType === '加开固定时间' || tempLessonParam.feedBackType === '加开短期固定时间'" ref="timeForm1" class="form" :label-width="90"
      :model="timeParam" :rules="timeRule1">
      <Row>
        <Col :span="26" >
          <Form-item label="选择买断时间" prop="openedTime">
            <Row :gutter="12">
              <Col :span="4">
                <Form-item prop="week">
                  <Select placeholder="星期" v-model="timeParam.week" transfer>
                    <Option v-for="item in $constant.week"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
                  </Select>
                </Form-item>
              </Col>
              <Col :span="5">
                <Form-item prop="startTime">
                  <Time-picker format="HH:mm" placeholder="开始时间" :clearable="false"
                    :steps="[1, 5]" :value="timeParam.startTimeStr"
                    @on-change="onChangeStratTime"></Time-picker>
                  </Form-item>
              </Col>
              <Col :span="1"></Col>
              <Col :span="5">
                <Form-item prop="endTime">
                  <Time-picker format="HH:mm" placeholder="结束时间" :clearable="false"
                    :steps="[1, 5]" :value="timeParam.endTimeStr"
                    @on-change="onChangeEndTime"></Time-picker>
                </Form-item>
              </Col>
              <i-col :span="6" >
                <Form-item prop="useDate" >
                  <Date-picker type="date" format="yyyy-MM-dd" placeholder="生效日期"
                               @on-change="onChangeUseDate" :clearable="false" :value="timeParam.useDateStr"></Date-picker>
                </Form-item>
              </i-col>
              <i-col :span="6" v-if="tempLessonParam.feedBackType === '加开短期固定时间'">
                <Form-item prop="endDate" >
                  <Date-picker type="date" format="yyyy-MM-dd" placeholder="截止有效期"
                               @on-change="onChangeEndDate" :clearable="false" :value="timeParam.endDateStr"></Date-picker>
                </Form-item>
              </i-col>
              <Col :span="2">
                <Button type="info" @click="addOpenedTime1">添加</Button>
              </Col>
            </Row>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <Form v-if="tempLessonParam.feedBackType === '加开固定时间' || tempLessonParam.feedBackType === '加开短期固定时间'" ref="timeListForm1" class="form" :label-width="90"
      :model="{}" :rules="timeListRule1">
      <Row>
        <Col :span="22" >
          <Form-item label="已选择时间" prop="openedTimeList" >
            <Row >
              <div v-for="(item, index) in openedTimeList" :key="item.week">
                <Col offset="1" span="19">
                  <label ><b>时间：{{ item.weekStr }} {{ item.startTimeStr }} - {{ item.endTimeStr }} , &nbsp;&nbsp; 生效日期：{{ item.useDateStr }}<span v-if="tempLessonParam.feedBackType === '加开短期固定时间'"> , &nbsp;&nbsp; 截止有效期：{{ item.endDateStr }}</span></b></label>
                </Col>
                <Col span="3">
                  <Button type="error" size="small" @click="removeOpenedTime(index)">删除</Button>
                </Col>
              </div>
            </Row>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <Form v-if="tempLessonParam.feedBackType === '加开临时时间'" ref="timeForm2" class="form" :label-width="100"
      :model="timeParam" :rules="timeRule2">
      <Row>
        <Col :span="22" >
          <Form-item label="选择上课时间" prop="openedTime">
            <Row :gutter="12">
              <Col :span="8">
                <Form-item prop="day">
                  <Date-picker type="date" placeholder="选择日期"
                    format="yyyy-MM-dd" :value="timeParam.dayStr"
                    @on-change="onChangeDate" :onfocus="false"></Date-picker>
                </Form-item>
              </Col>
              <Col :span="6">
                <Form-item prop="startTime">
                  <Time-picker format="HH:mm" placeholder="开始时间" :clearable="false"
                    :steps="[1, 5]" :value="timeParam.startTimeStr"
                    @on-change="onChangeStratTime" :onfocus="false"></Time-picker>
                  </Form-item>
              </Col>
              <Col :span="1"></Col>
              <Col :span="6">
                <Form-item prop="endTime">
                  <Time-picker format="HH:mm" placeholder="结束时间" :clearable="false"
                    :steps="[1, 5]" :value="timeParam.endTimeStr"
                    @on-change="onChangeEndTime" :onfocus="false"></Time-picker>
                </Form-item>
              </Col>
              <Col :span="3">
                <Button type="info" @click="addOpenedTime2">添加</Button>
              </Col>
            </Row>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <Form v-if="tempLessonParam.feedBackType === '加开临时时间'" ref="timeListForm2" class="form" :label-width="100"
      :model="{}" :rules="timeListRule2">
      <Row>
        <Col :span="24" >
          <Form-item label="已选择时间" prop="openedTimeList" >
            <Row >
              <div v-for="(item, index) in openedTimeList" :key="index">
                <Col offset="1" span="7">
                  <label ><b>{{ item.dayStr }} {{ item.startTimeStr }}-{{ item.endTimeStr }}</b></label>
                </Col>
                <Col span="2">
                  <Button type="error" size="small" @click="removeOpenedTime(index)">删除</Button>
                </Col>
              </div>
            </Row>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <Form v-if="tempLessonParam.feedBackType !== '其他' && tempLessonParam.feedBackType !== '开绑定权限' && tempLessonParam.feedBackType !== '开临时约课权限'" :label-width="90">
      <Row>
        <Col :span="22">
          <Form-item label="外教留言">
            <Input type="textarea" :rows="3" :maxlength="500" v-model="tempLessonParam.feedRemark"
              placeholder="选填，输入留言给外教，支持中文自动翻译">
            </Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="false" @click="add">保存</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'AddMatchCenterModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      tchId: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let self = this
      return {
        visible: this.value,
        tempLessonParam: {
          tchId: '',
          tchName: '',
          feedBackType: '加开固定时间',
          content: '',
          otherContent: '',
          feedRemark: ''
        },
        timeParamEndDateStr: '',
        timeParam: {
          week: null,
          startTime: '',
          endTime: '',
          startTimeStr: '',
          endTimeStr: '',
          useDate: '',
          useDateStr: '',
          endDate: '',
          endDateStr: '',
          day: '',
        },
        loadingAdd: false,
        openedTimeList: [],
        timeRule:{},
        timeRule1: {
          week: [
            { type: 'integer', required: true, message: '请选择星期' }
          ],
          startTime: [
            { type: 'integer', required: true, message: '请选择开始时间' },
            { validator (rule, value, callback, source, options) {
              let endTime = self.timeParam.endTime
              let errors = []
              if (endTime !== '' && value >= endTime) {
                errors.push('开始时间应在结束时间之前 ')
              }
              callback(errors)
            } }
          ],
          endTime: [
            { type: 'integer', required: true, message: '请选择结束时间' }
          ],
          useDate: [
            { type: 'integer', required: true, message: '请选择有效日期' }
          ],
          openedTime: [
            { validator (rule, value, callback, source, options) {
              let openedTimeList = self.openedTimeList
              let week = self.timeParam.week
              let startTime = self.timeParam.startTime
              let endTime = self.timeParam.endTime
              if (week === '' || startTime === '' || endTime === '' ||
                startTime >= endTime) {
                return
              }
              let errors = []
              openedTimeList.forEach(element => {
                let tmpWeek = element.week
                let tmpStratTime = element.startTime
                let tmpEndTime = element.endTime
                if (week === tmpWeek &&
                  ((tmpStratTime < startTime && tmpEndTime > startTime) ||
                  (tmpStratTime < endTime && tmpEndTime > endTime) ||
                  (tmpStratTime >= startTime && tmpEndTime <= endTime))) {
                  errors.push('添加的时间与 ' + self.$constant.weekZh[week] + ' ' +
                    element.startTimeStr + ' - ' + element.endTimeStr + ' 冲突')
                }
              })
              callback(errors)
            } }
          ],
        },
        timeListRule1: {
          openedTimeList: [
            { validator (rule, value, callback, source, options) {
              let openedTimeList = self.openedTimeList
              let errors = []
              if (openedTimeList.length <= 0) {
                errors.push('请添加时间')
              }
              callback(errors)
            } }
          ]
        },
        timeRule2: {
          day: [
            { type: 'integer', required: true, message: '请选择日期'}
          ],
          startTime: [
            { type: 'integer', required: true, message: '请选择开始时间'},
            { validator (rule, value, callback, source, options) {
              let endTime = self.timeParam.endTime
              let errors = []
              if (endTime !== '' && value >= endTime) {
                errors.push('开始时间应在结束时间之前 ')
              }
              callback(errors)
            } }
          ],
          endTime: [
            { type: 'integer', required: true, message: '请选择结束时间'}
          ],
          openedTime: [
            { validator (rule, value, callback, source, options) {
              let day = self.timeParam.day
              let startTime = self.timeParam.startTime
              let errors = []
              let nowTime = new Date().getTime() / 1000
              if (day !== '' && startTime !== '' && nowTime >= (day + startTime)) {
                errors.push('开始时间应在当前时间之后')
                callback(errors)
                return
              }
              let openedTimeList = self.openedTimeList
              let endTime = self.timeParam.endTime
              if (day === '' || startTime === '' || endTime === '' ||
                startTime >= endTime) {
                return
              }
              openedTimeList.forEach(element => {
                let tmpDay = element.day
                let tmpStratTime = element.startTime
                let tmpEndTime = element.endTime
                if (day === tmpDay &&
                  ((tmpStratTime < startTime && tmpEndTime > startTime) ||
                  (tmpStratTime < endTime && tmpEndTime > endTime) ||
                  (tmpStratTime >= startTime && tmpEndTime <= endTime))) {
                  errors.push('添加的时间与 ' + element.dayStr + ' ' +
                    element.startTimeStr + '-' + element.endTimeStr + ' 冲突')
                }
              })
              callback(errors)
            } }
          ],
        },
        timeListRule2: {
          openedTimeList: [
            { validator (rule, value, callback, source, options) {
              let openedTimeList = self.openedTimeList
              let errors = []
              if (openedTimeList.length <= 0) {
                errors.push('请添加时间')
              }
              callback(errors)
            } }
          ]
        },
      }
    },
    methods: {
      onChangeFeedBackType (val) {
        this.tempLessonParam.feedBackType = val
        this.openedTimeList = []
        this.timeParam = {
          week: null,
          startTime: '',
          endTime: '',
          startTimeStr: '',
          endTimeStr: '',
          useDate: '',
          useDateStr: '',
          day: '',
        }
      },
      addOpenedTime1 () {
        let self = this
        self.$refs.timeForm1.validate((valid) => {
          if (!valid) {
            return
          }
          if (self.tempLessonParam.feedBackType === '加开短期固定时间') {
            if (!this.timeParam.endDate) {
              this.$Message.warning('请选择截止有效期')
              return
            }
            if (this.timeParam.endDate <= this.timeParam.useDate) {
              this.$Message.warning('截止有效期应在生效日期之后')
              return
            }
          }
          let openedTime = {}
          openedTime.week = this.timeParam.week
          openedTime.weekStr = this.$constant.weekZh[this.timeParam.week]
          openedTime.startTime = this.timeParam.startTime
          openedTime.startTimeStr = this.timeParam.startTimeStr
          openedTime.endTime = this.timeParam.endTime
          openedTime.endTimeStr = this.timeParam.endTimeStr
          openedTime.useDate = this.timeParam.useDate
          openedTime.useDateStr = this.timeParam.useDateStr
          openedTime.endDate = this.timeParam.endDate
          openedTime.endDateStr = this.timeParam.endDateStr
          this.openedTimeList.push(openedTime)
          this.timeParam.week = null
          this.timeParam.startTime = ''
          this.timeParam.endTime = ''
          this.timeParam.startTimeStr = ''
          this.timeParam.endTimeStr = ''
        })
      },
      addOpenedTime2 () {
        let self = this
        self.$refs.timeForm2.validate((valid) => {
          if (!valid) {
            return
          }
          let openedTime = {}
          openedTime.day = self.timeParam.day
          openedTime.dayStr = self.timeParam.dayStr
          openedTime.startTime = self.timeParam.startTime
          openedTime.startTimeStr = self.timeParam.startTimeStr
          openedTime.endTime = self.timeParam.endTime
          openedTime.endTimeStr = self.timeParam.endTimeStr
          self.openedTimeList.push(openedTime)
          this.timeParam = {
            week: null,
            startTime: '',
            endTime: '',
            startTimeStr: '',
            endTimeStr: '',
            useDate: '',
            useDateStr: '',
            day: '',
          }
        })
      },
      removeOpenedTime (index) {
        this.openedTimeList.splice(index, 1)
      },
      onChangeDate (val) {
        this.timeParam.dayStr = val
        this.timeParam.day = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'))
      },
      onChangeStratTime (val) {
        this.timeParam.startTime = this.$dateUtil.getSecondByHm(val)
        this.timeParam.startTimeStr = val
      },
      onChangeEndTime (val) {
        this.timeParam.endTime = this.$dateUtil.getSecondByHm(val)
        this.timeParam.endTimeStr = val
      },
      onChangeUseDate (val) {
        this.timeParam.useDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'))
        this.timeParam.useDateStr = val
      },
      onChangeEndDate (val) {
        this.timeParam.endDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'))
        this.timeParam.endDateStr = val
      },
      add () {
        let self = this
        if (self.tempLessonParam.feedBackType === '其他') {
          if (!self.tempLessonParam.otherContent) {
            this.$Message.error('请输入留言内容')
            return
          }
          self.$http.post('/stageReport/fm-message-center-add', {
            tchId: self.tempLessonParam.tchId,
            bizType: '其他',
            feedContent: self.tempLessonParam.otherContent,
            feedRemark: self.tempLessonParam.feedRemark
          }).then(function (res) {
            if (res && res.status === 'ok') {
              self.successCallback()
              self.visible = false
              self.$Message.success('提交成功!')
            } else {
              self.$Message.error({ content: res.msg || '提交失败', duration: 5 })
            }
          })
          return
        }
        if (self.tempLessonParam.feedBackType === '开绑定权限') {
          if (!self.tempLessonParam.otherContent) {
            this.$Message.error('请输入申请理由')
            return
          }
          self.$http.post('/stageReport/fm-message-center-add', {
            tchId: self.tempLessonParam.tchId,
            bizType: '开绑定权限',
            feedContent: self.tempLessonParam.otherContent
          }).then(function (res) {
            if (res && res.status === 'ok') {
              self.successCallback()
              self.visible = false
              self.$Message.success('提交成功!')
            } else {
              self.$Message.error({ content: res.msg || '提交失败', duration: 5 })
            }
          })
          return
        }
        if (self.tempLessonParam.feedBackType === '开临时约课权限') {
          if (!self.tempLessonParam.otherContent) {
            this.$Message.error('请输入申请理由')
            return
          }
          self.$http.post('/stageReport/fm-message-center-add', {
            tchId: self.tempLessonParam.tchId,
            bizType: '开临时约课权限',
            feedContent: self.tempLessonParam.otherContent
          }).then(function (res) {
            if (res && res.status === 'ok') {
              self.successCallback()
              self.visible = false
              self.$Message.success('提交成功!')
            } else {
              self.$Message.error({ content: res.msg || '提交失败', duration: 5 })
            }
          })
          return
        }
        if(self.openedTimeList.length === 0) {
          this.$Message.error('请添加时间')
          return
        }
        self.$http.post('/stageReport/fm-message-center-add', {
          tchId: self.tempLessonParam.tchId,
          bizType: self.tempLessonParam.feedBackType,
          feedContent: JSON.stringify(self.openedTimeList),
          feedRemark: self.tempLessonParam.feedRemark
        }).then(function (res) {
          if (res && res.status === 'ok') {
            self.successCallback()
            self.visible = false
            self.$Message.success('提交成功!')
          } else {
            self.$Message.error({
              content: res.data(),
              duration: 5
            })
          }
        }).catch(function (e) {
        })
      },
      delect () {
        let self = this
        if (self.openedTimeList.length === 0) {
          self.$http.get('/tch/time/deleteBookOpenedTime?tchId=' + self.tchId).then(function (res) {
            if (res && res.data > 0) {
              self.successCallback()
              self.visible = false
              self.$Message.success('删除成功!')
            } else {
              self.successCallback()
              self.$Message.error({
                content: res.data(),
                duration: 5
              })
            }
          })
        } else {
          self.openedTimeList.forEach(element => {
            element.tchId = self.tchId
          })
          self.$http.post('/tch/time/addBookOpenedTime', {}, {
            transformRequest: [function (data, headers) {
              return JSON.stringify(self.openedTimeList)
            }],
            headers: {'Content-Type': 'application/json;charset=utf-8'},
          }).then(function (res) {
            if (res && res.data > 0) {
              self.successCallback()
              self.$Message.success('删除成功')
            } else {
              self.$Message.error({
                content: res.data(),
                duration: 5
              })
            }
          }).catch(function (e) {
          })
        }
      },
    },
    watch: {
      value (val) {
        if (val === true) {
          this.openedTimeList = []
        }
        this.visible = val
      },
      visible (val) {
        if (val === false) {
          this.openedTimeList = []
          this.timeParam = {
            day: '',
            week: null,
            startTime: '',
            endTime: '',
            startTimeStr: '',
            endTimeStr: '',
            useDate: '',
            useDateStr: ''
          }
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddMatchCenterModal.vue?31ada554